import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { wellnessBaseUrl } from "network";

export const doctorSlice = createApi({
    reducerPath: "doctorSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: wellnessBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getDoctors: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/doctor/list?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        sendOtpToDoctor: builder.mutation({
            query: (body) => ({
                url: "/doctor/sendOtp",
                method: "POST",
                body,
            }),
        }),

        registerDoctor: builder.mutation({
            query: (body) => ({
                url: "/doctor/register",
                method: "POST",
                body,
            }),
        }),

        addService: builder.mutation({
            query: (body) => ({
                url: `/doctor/service_linked`,
                method: "POST",
                body, 
            }),
        }),

        getSingleDoctor: builder.query({
            query: (id) => ({
                url: `/doctor/singleDetail/${id}`,
                method: "GET",

            }),
        }),

        // ✅ Delete Category
        deleteDoctor: builder.mutation({
            query: (id) => ({
                url: `/doctor/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetDoctorsQuery,
    useSendOtpToDoctorMutation,
    useRegisterDoctorMutation,
    useAddServiceMutation,
    useGetSingleDoctorQuery,
    useDeleteDoctorMutation
} = doctorSlice;
